import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormGroup, FormControl, Validators} from '@angular/forms';
import {Patient} from '../../_models';
import {PatientService} from '../../_services';
import {first} from 'rxjs/operators';
import {getUser} from '../../../assets/utils.js';

@Component({
  selector: 'app-create-abeille',
  templateUrl: './create-abeille.component.html',
  styleUrls: ['./create-abeille.component.scss']
})
export class CreateAbeilleComponent implements OnInit {

  @Output() refreshEvent = new EventEmitter<string>();

  step = 1;
  lastname = '';
  firstname = '';
  birthday = '';
  selectedMascotte = 1;
  errors = [];
  show = true;

  abeilleForm = new FormGroup({
      lastname: new FormControl('', [Validators.required]),
      firstname: new FormControl(''),
      birthday: new FormControl(''),
  });

  constructor(private patientService: PatientService) { }

  ngOnInit() {
  }

  goStep(step: number) {
    this.step = step;
  }

  selectMascotte(id) {
    this.selectedMascotte = id;
  }

  checkAbeilleInfos() {

    this.errors = [];
    let isOK = true;

    if (!this.abeilleForm.value.lastname) {
      this.errors[`lastname`] = true;
      isOK = false;
    }
    if (!this.abeilleForm.value.firstname) {
      this.errors[`firstname`] = true;
      isOK = false;
    }
    if (!this.abeilleForm.value.birthday) {
      this.errors[`birthday`] = true;
      isOK = false;
    }

    if (!isOK) {
      return;
    }

    this.goStep(2);
  }

  onSubmit() {
    const abeille = new Patient({});
    abeille.lastName = this.abeilleForm.value.lastname;
    abeille.firstName = this.abeilleForm.value.firstname;
    abeille.birthday = this.abeilleForm.value.birthday;
    abeille.idAvatar = this.selectedMascotte;
    abeille.archived = false;
    abeille.userId = getUser().id;

    this.patientService.registerByUserId(getUser().id, abeille).pipe(first()).subscribe(result => {
        this.step = 1;
        this.abeilleForm.reset();
        this.refreshEvent.next();

    });
  }
}
